import ApiService from '../api.service'
import getCurrentCompanyId from '../company.service'
import type {
  IFetchBarChartDataParams,
  IFetchWidgetDataParams,
  IBarChartSourceData,
  IIndicatorSourceData,
  ITotalizerSourceData,
} from '@/interfaces/api/widget'

const CompanyDashboardResource = {
  getDashboards: () =>
    ApiService.get(`/v1/companies/${getCurrentCompanyId()}/dashboards`),

  getDashboard: (dashboardId: number) =>
    ApiService.get(`/v1/companies/${getCurrentCompanyId()}/dashboards/${dashboardId}`),

  createDashboard: (params: { name: string; description?: string; dashboard_type: string }) =>
    ApiService.post(`/v1/companies/${getCurrentCompanyId()}/dashboards`, { dashboard: params }),

  updateDashboard: (dashboardId: number, params: { name?: string; description?: string; dashboard_type?: string }) =>
    ApiService.put(`/v1/companies/${getCurrentCompanyId()}/dashboards/${dashboardId}`, { dashboard: params }),

  deleteDashboard: (dashboardId: number) =>
    ApiService.delete(`/v1/companies/${getCurrentCompanyId()}/dashboards/${dashboardId}`),

  createWidget: (dashboardId: number, params: object) =>
    ApiService.post(
      `/v1/companies/${getCurrentCompanyId()}/dashboards/${dashboardId}/widgets`,
      { widget: params }
    ),

  updateWidget: (dashboardId: number, widgetId: number, params: object) =>
    ApiService.put(
      `/v1/companies/${getCurrentCompanyId()}/dashboards/${dashboardId}/widgets/${widgetId}`,
      { widget: params }
    ),

  deleteWidget: (dashboardId: number, widgetId: number) =>
    ApiService.delete(
      `/v1/companies/${getCurrentCompanyId()}/dashboards/${dashboardId}/widgets/${widgetId}`
    ),

  updateLayout: (dashboardId: number, widgets: Array<{ id: number; x: number; y: number; w: number; h: number }>) =>
    ApiService.put(
      `/v1/companies/${getCurrentCompanyId()}/dashboards/${dashboardId}/widgets/layout`,
      { widgets }
    ),

  getIndicatorsData: ({ dashboardId, startDate, endDate }: IFetchWidgetDataParams) =>
    ApiService.get(
      `/v1/companies/${getCurrentCompanyId()}/dashboards/${dashboardId}/widgets/indicators_data`,
      { start_date: startDate, end_date: endDate },
    ) as Promise<IIndicatorSourceData[]>,

  getBarChartData: ({ dashboardId, startDate, endDate, windowPeriod }: IFetchBarChartDataParams) =>
    ApiService.get(
      `/v1/companies/${getCurrentCompanyId()}/dashboards/${dashboardId}/widgets/bar_chart_data`,
      { start_date: startDate, end_date: endDate, window_period: windowPeriod },
    ) as Promise<IBarChartSourceData[]>,

  getTotalizersData: ({ dashboardId, startDate, endDate }: IFetchWidgetDataParams) =>
    ApiService.get(
      `/v1/companies/${getCurrentCompanyId()}/dashboards/${dashboardId}/widgets/totalizers_data`
      + `?start_date=${startDate}&end_date=${endDate}`
    ) as Promise<ITotalizerSourceData[]>,
}

export default CompanyDashboardResource
